import React from 'react'
import {LoadingData} from '../../../../components/LoadingData'
import {Link} from 'react-router-dom'

const DemandeDemontageDetailsHeader = (props) => {
  const {demontageData, showTypePieces, loading} = props

  const infoDisplay = () => {
    const vehicule: any = demontageData?.demandeDemontage?.vehicule
    return (
      <>
        {loading ? (
          <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
        ) : (
          <div className='card-body py-5'>
            <div>
              <div className='d-flex'>
                <div className='w-50 '>
                  <div className='d-flex align-items-center mb-2'>
                    <p className='text-gray-800 text-hover-primary fs-2 fw-bolder me-5 mb-0'>
                      <>
                        {vehicule?.vehicule?.modele?.marque?.nom} {vehicule?.vehicule?.modele?.nom}{' '}
                        [{vehicule?.immatriculation}]
                      </>
                    </p>
                  </div>
                  {showTypePieces && (
                    <div className='fw-bold fs-6 mb-4 pe-2' style={{textAlign: 'justify'}}>
                      <span className='text-gray-400 text-hover-primary me-5 mb-2'>
                        {demontageData?.typePieces?.length &&
                          demontageData?.typePieces?.map((res) => res.nom).join(' ,')}
                      </span>
                    </div>
                  )}
                  <div className='text-gray-600'>
                    Demande de démontage n°{' '}
                    <span className='text-primary fw-bold'>
                      {demontageData?.demandeDemontage?.id}
                    </span>
                  </div>
                </div>
                <div className='d-flex w-50 flex-wrap flex-stack'>
                  <div className='d-flex flex-column flex-grow-1'>
                    <div className='d-flex flex-wrap justify-content-end'>
                      <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                        <div className='d-flex align-items-center'>
                          <div className='fs-2 fw-bolder'>{demontageData?.typePieces?.length}</div>
                        </div>
                        <div className='fw-bold fs-6 text-gray-400'>Nombre de pièces</div>
                      </div>

                      <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                        <div className='d-flex align-items-center'>
                          <div className='fs-2 fw-bolder'>
                            {demontageData?.demandeDemontage?.priorite}
                          </div>
                        </div>
                        <div className='fw-bold fs-6 text-gray-400'>Priorité</div>
                      </div>

                      <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                        <div className='d-flex align-items-center'>
                          <div className='fs-2 fw-bolder'>
                            {demontageData?.demandeDemontage?.statut?.libelle}
                          </div>
                        </div>
                        <div className='fw-bold fs-6 text-gray-400'>Statut</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    )
  }

  return (
    <>
      <div className='card mb-5 mb-xl-10'>{loading ? <LoadingData /> : infoDisplay()}</div>
    </>
  )
}

export {DemandeDemontageDetailsHeader}
